import { render, staticRenderFns } from "./LabourerShiftReport.vue?vue&type=template&id=c7a646b4&scoped=true&"
import script from "./LabourerShiftReport.vue?vue&type=script&lang=js&"
export * from "./LabourerShiftReport.vue?vue&type=script&lang=js&"
import style0 from "./LabourerShiftReport.vue?vue&type=style&index=0&id=c7a646b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a646b4",
  null
  
)

export default component.exports